angular.module('Itao.IndicatorMap').directive('transposedSetTable', function (d3, mapConfig, IndicatorSetHandling, UtilityService, $compile) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param districts
   * @returns {string}
   */
  function prepareTableHead(districts) {
    var numberOfDistricts = districts.length;
    var width = 86 / numberOfDistricts;
    return '<thead><tr><th width="15%"></th>' + districts.map(function (district) {
      return '<th width="' + width + '%">' + district.key + '</th>';
    }) + '</tr></thead>';
  }

  /**
   *
   * @param indicator
   * @param district
   * @param layer
   * @param colorSets
   * @param selectedIndicator
   * @returns {string}
   */
  function bodyRowDistrictField(indicator, district, layer, colorSets, selectedIndicator) {
    var value = '-';
    var tooltip = '';
    var tdClass = '';
    var decimals = false;
    var legend = false;

    // has Legend
    if (selectedIndicator && layer.legend && layer.legend[selectedIndicator.uid] != null && layer.legend[selectedIndicator.uid].map != null) {
      legend = layer.legend[selectedIndicator.uid].map;
    }

    if (indicator.categorical) {
      // use icon as value
      if (legend) {
        // icon plus tooltip
        if (layer[district.uid][indicator.uid] != null) {
          value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg(UtilityService.scaleForValue(layer.legend[selectedIndicator.uid].map.scales, colorSets[layer.legend[selectedIndicator.uid].map.colorSet], layer[district.uid][indicator.uid])) + '</span>';
        } else {
          if (layer.legend[selectedIndicator.uid].map.hasNoValueText !== '') {
            value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg({icon: 'no-value'}) + '</span>';
          } else {
            value = '<span style="display: block; text-align: center; height:16px;">-</span>';
          }
        }
        if (layer.descriptions[district.uid][indicator.uid] != null) {
          tooltip = layer.descriptions[district.uid][indicator.uid];
        }
      } else {
        // direct value
        if (layer.descriptions[district.uid][indicator.uid] != null) {
          value = layer.descriptions[district.uid][indicator.uid];
        } else {
          value = '<span style="display: block; text-align: center; height:16px;">-</span>';
        }
      }
    } else {
      tdClass = " class='numeric'";

      // decimals
      if (legend && legend.decimals && legend.decimals !== 0) {
        decimals = legend.decimals;
      } else {
        decimals = indicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
      }

      // use normal values
      if (layer[district.uid][indicator.uid] != null) {
        value = ((indicator.unit === '%') ? (germanNumberFormat('.' + decimals + 'f')(+layer[district.uid][indicator.uid]) + '') : (germanNumberFormat(',.' + decimals + 'f')(+layer[district.uid][indicator.uid])));
        value = "<span class='centered-number'>" + value + "</span>";
        if (layer.descriptions[district.uid][indicator.uid]) {
          tooltip = layer.descriptions[district.uid][indicator.uid];
        }
      } else if (layer.descriptions[district.uid][indicator.uid] && layer.descriptions[district.uid][indicator.uid].length > 0) {
        value = layer.descriptions[district.uid][indicator.uid];
        // ToDo: auch hier zentrieren? Sind eigentlich texte - gelegentlich aber auch für werte genutzt (8-10, <3,...)
        if (value.replace(/<(?:.|\n)*?>/gm, '').length < 7) {
          value = "<span class='centered-number'>" + value + "</span>";
        }
      } else {
        value = "<span class='centered-number'>-</span>";
      }
    }

    return '<td' + tdClass + '><div tooltip-append-to-body="true" uib-tooltip-html="\'' + ((tooltip != null) ? tooltip : '') + '\'">' + value + '</div></td>';
  }

  /**
   *
   * @param indicator
   * @param districts
   * @param layer
   * @param colorSets
   * @param insideList
   * @param selectedIndicator
   * @returns {string}
   */
  function bodyRow(indicator, districts, layer, colorSets, insideList, selectedIndicator) {
    if (!indicator.hasData) return '';
    return '<tr class="' + (insideList ? 'inside-indicator-list-row' : 'indicator-row') + '"><td>' + indicator.name + '</td>' + districts.map(function (district) {
      return bodyRowDistrictField(indicator, district, layer, colorSets, selectedIndicator);
    }) + '</tr>';
  }

  /**
   * @param layer
   * @param indicatorsOrLists
   * @param districts
   * @param colorSets
   */
  function prepareTableBody(layer, indicatorsOrLists, districts, colorSets, flatIndicators) {
    var selectedIndicator = flatIndicators.filter(function (indicator) {
      return indicator.isDefault;
    })[0];
    return indicatorsOrLists.map(function (indicatorOrList) {
      var row = '';
      if (isList(indicatorOrList)) {
        row += '<tr class="indicator-list-row"><td><b>' + indicatorOrList.title + '</b></td>' + districts.map(function () {
          return '<td></td>';
        }) + '</tr>';
        row += indicatorOrList.indicators.map(function (indicator) {
          return bodyRow(indicator, districts, layer, colorSets, true, selectedIndicator);
        });
      } else {
        row += bodyRow(indicatorOrList, districts, layer, colorSets, false, selectedIndicator);
      }
      return row;
    });
  }

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setTable.html',
    scope: {
      selectedIndicatorSet: '=',
      layer: '=',
      disabledDistrictKeys: '=',
      colorSets: '=',
      config: '=',
      exportData: '='
    },
    link: function (scope, element) {

      var filterEmptyIndicators = function (indicator) {
        if (indicator.class !== 'indicator') {
          indicator.indicators = indicator.indicators.filter(function (indicator) {
            return hasData(indicator);
          });
        }
      };

      var hasData = function (indicator) {
        indicator.hasData = false;
        angular.forEach(scope.layer.districts, function (district) {
          if (scope.layer[district.uid][indicator.uid] || scope.layer.descriptions[district.uid][indicator.uid]) indicator.hasData = true;
        });
        return indicator.hasData;
      };

      function rerender() {
        if (scope.layer && scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (scope.selectedIndicatorSet != null && scope.layer != null && scope.disabledDistrictKeys != null && scope.colorSets != null) {
          var sortedListsAndIndicators = IndicatorSetHandling.sortIndicatorsAndLists(scope.selectedIndicatorSet);
          var flatIndicators = IndicatorSetHandling.sortIndicatorsAndListsFlat(scope.selectedIndicatorSet);

          sortedListsAndIndicators = sortedListsAndIndicators.filter(function (indicator) {
            if (indicator.class === "indicator") {
              return hasData(indicator);
            }
            return true;
          });

          sortedListsAndIndicators.map(filterEmptyIndicators);
          var districts = Object.keys(scope.layer.districts).map(function (districtUid) {
            return scope.layer.districts[districtUid];
          }).filter(function (district) {
            return scope.disabledDistrictKeys.indexOf(district.key) === -1;
          });

          var head = prepareTableHead(districts);

          var body = prepareTableBody(scope.layer, sortedListsAndIndicators, districts, scope.colorSets.reduce(function (acc, colorSet) {
            acc[colorSet.uid] = colorSet;
            return acc;
          }, {}), flatIndicators);
          element.find('table').html(head + body);
          $compile(element.find('table').contents())(scope);

          scope.exportData = getTableExportData(scope.layer, sortedListsAndIndicators, districts);
        }
      }

      var getTableExportData = function (layer, indicators, districts) {
        var data = [];
        var districtRow = [];
        districtRow.push("");
        districts.forEach(function (district) {
          districtRow.push(district.key)
        });

        data.push(districtRow);
        indicators.forEach(function (indicator) {
          var districtValues = [];
          districtValues.push(indicator.name);
          if (!indicator.indicators) {
            districts.forEach(function (district) {
              var value;
              if (layer[district.uid][indicator.uid] != null) {
                value = ((indicator.unit === '%') ? (germanNumberFormat('.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f')(+layer[district.uid][indicator.uid])/* + '%' */) : (germanNumberFormat(',.' + mapConfig.absoluteIndicatorsDecimalPlaces + 'f')(+layer[district.uid][indicator.uid])));
              } else if (layer.descriptions[district.uid][indicator.uid] != null) {
                value = layer.descriptions[district.uid][indicator.uid].replace(/<(?:.|\n)*?>/gm, '');
              } else {
                value = "";
              }
              districtValues.push(value);
            });
          }
          data.push(districtValues);
        });

        return data;
      };

      var selectedIndicatorSetWatcher = scope.$watch('selectedIndicatorSet', rerender, true);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var colorSetsWatcher = scope.$watchCollection('colorSets', rerender);
      var layerWatcher = scope.$watch('layer', rerender, true);

      element.on('$destroy', function () {
        selectedIndicatorSetWatcher();
        disabledDistrictKeysWatcher();
        layerWatcher();
        colorSetsWatcher();
      });
    }
  };
});
